import { MissionToStaff } from '../../lib/types/models/mission-to-staff/mission-to-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getMissionTrackingAffectedStaffs(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.getAffectedStaffs.url, { id }))
    .get<MissionToStaff[]>()
}
